<div class="navblock">
  <app-group-filter #groupFilter [isEditable]="false"></app-group-filter>
  <div></div>
  <div class="inputgroup">
    <input type="text" class="dtpickerupleft" value="" />
  </div>
  <button id="setintervalbtn" class="btn_blue">{{'Apply'|translate }}</button>
</div>
<div class="tablewrap gas-top">

  <div class="gas-small-item">
    <div class="gas-sub-item" id="drivers_total">
      <div class="azs_item_value azs_item_green"></div>
      <div class="azs_item_name">{{'Drivers' | translate}}</div>
    </div>
    <div class="gas-sub-item" id="trips_total">
      <div class="azs_item_value azs_item_green"></div>
      <div class="azs_item_name">{{'Trips' | translate}}</div>
    </div>
  </div>

  <div class="gas-small-item">
    <div class="gas-sub-item" id="total_mileage">
      <div class="azs_item_value azs_item_green"></div>
      <div class="azs_item_name">{{'Mileage' | translate}}</div>
    </div>
    <div class="gas-sub-item" id="violations_count">
      <div class="azs_item_value azs_item_red"></div>
      <div class="azs_item_name">{{'Violations' | translate}}</div>
    </div>
  </div>
  <div class="gas-small-item">
    <div class="gas-sub-item" id="total_penalty">
      <div class="azs_item_value azs_item_red"></div>
      <div class="azs_item_name">{{'Penalty' | translate}}</div>
    </div>
    <div class="gas-sub-item" id="violations_duration">
      <div class="azs_item_value azs_item_red"></div>
      <div class="azs_item_name">{{'Violations duration' | translate}}</div>
    </div>
  </div>

  <div class="gas-item" id="daily_violations_trend">
    <div class="chart_wrap">
      <canvas></canvas>
    </div>
  </div>

  <div class="gas-item" id="top_drivers">
    <div class="chart_wrap">
      <canvas></canvas>
    </div>
  </div>

  <div class="gas-item" id="daily_mileage_trend">
    <div class="chart_wrap">
      <canvas></canvas>
    </div>
  </div>


  <div class="gas-item" id="daily_fuel_trend">
    <div class="chart_wrap">
      <canvas></canvas>
    </div>
  </div>

  <div class="gas-item" id="violations_pie">
    <div class="chart_wrap">
      <canvas></canvas>
    </div>
  </div>

  <div class="gas-item" id="top_drivers_mileage">
    <div class="chart_wrap">
      <canvas></canvas>
    </div>
  </div>

</div>

<div class="tablenav">
  <app-pagination [viewmode]="'print'" ></app-pagination>
</div>
